import { Injectable, Component } from '@angular/core';
import { ComplaintTabsPage } from '../../pages/complaint-tabs/complaint-tabs';
import { BillReportPage } from '../../pages/bill-report/bill-report';
import { BillingPaymentsPage } from '../../pages/billing-payments/billing-payments';
import { FeedbackPage } from '../../pages/feedback/feedback';
import { ForgotPassPage } from '../../pages/forgot-pass/forgot-pass';
import { MeterPage } from '../../pages/meter/meter';
import { MySocietyPage } from '../../pages/my-society/my-society';
import { MyStaffTabsPage } from '../../pages/my-staff-tabs/my-staff-tabs';
import { NoticesPage } from '../../pages/notices/notices';
import { VisitorTabsPage } from '../../pages/visitor-tabs/visitor-tabs';
import { ProfilePage } from '../../pages/profile/profile';
import { SettingsPage } from '../../pages/settings/settings';
import { MyVehiclePage } from '../../pages/my-vehicle/my-vehicle';
import { PaymentListPage } from '../../pages/payment-list/payment-list';
import { AddMemberPage } from '../../pages/add-member/add-member';
import { BillingListPage } from '../../pages/billing-list/billing-list';
import { PermissionCheckPipe } from '../../pipes/permission-check/permission-check';
import { LoginProvider } from '../login/login';
import { SurveyPage } from '../../pages/survey/survey';
import { PassPurposePage } from '../../pages/pass-purpose/pass-purpose';
import { AddComplaintsPage } from '../../pages/add-complaints/add-complaints';
import { FacilitySelectLocationPage } from '../../pages/facility-select-location/facility-select-location';
import { AddVehiclePage } from '../../pages/add-vehicle/add-vehicle';
import { TranslateService } from '@ngx-translate/core';
import { EventsPage } from '../../pages/Event/event';

@Injectable()
export class AppSearchItemsProvider {

  allItems = [
    { name: 'SEARCH_ITEM.RAISE_COMPLAINTS', page: AddComplaintsPage, mod: "COM", type: "CREATE" },
    { name: 'SEARCH_ITEM.CLOSED_COMPLAINTS', page: ComplaintTabsPage, data: { index: 1 }, mod: "COM", type: "READ" },
    { name: 'SEARCH_ITEM.OPEN_COMPLAINTS', page: ComplaintTabsPage, data: { index: 0 }, mod: "COM", type: "READ" },
    { name: 'SEARCH_ITEM.ALL_COMPLAINTS', page: ComplaintTabsPage, data: { index: 2 }, mod: "COM", type: "READ" },
    { name: 'SEARCH_ITEM.BILLS', page: BillingListPage, data: { index: 0 }, mod: "BILL", type: "READ" },
    { name: 'SEARCH_ITEM.PAYMENT', page: PaymentListPage, data: { index: 1 }, mod: "PMT", type: "READ" },
    { name: 'SEARCH_ITEM.BOUNCED_CHEQUES', page: PaymentListPage, data: { type: "RETURNED" }, mod: "PMT", type: "READ" },
    { name: 'SEARCH_ITEM.MY_COMPLEX', page: MySocietyPage, mod: "NTC", type: "READ" },
    { name: 'SEARCH_ITEM.NOTICES', page: NoticesPage, mod: "NTC", type: "READ" },
    { name: 'SEARCH_ITEM.EVENTS', page: EventsPage, mod: "EVNT", type: "READ" },
    { name: 'SEARCH_ITEM.SURVEYS', page: SurveyPage, mod: "SURVEY", type: "READ" },
    { name: 'SEARCH_ITEM.FEEDBACK', page: FeedbackPage, mod: "URD", type: "READ" },
    { name: 'SEARCH_ITEM.PROFILE', page: ProfilePage, mod: "URD", type: "READ" }, 
    { name: 'SEARCH_ITEM.SETTINGS', page: SettingsPage, mod: "STG", type: "READ" },
    { name: 'SEARCH_ITEM.ACCOUNT_SUMMARY', page: BillingPaymentsPage, mod: "BILL", type: "READ" },
    { name: 'SEARCH_ITEM.ADD_NEW_MEMBER', page: AddMemberPage, mod: 'FMB', type: 'CREATE' },
    { name: 'SEARCH_ITEM.BILL_REPORT', page: BillReportPage, mod: "BILL", type: "READ" },
    { name: 'SEARCH_ITEM.BOOK_AMENITIES', page: FacilitySelectLocationPage, mod: "FBK", type: "CREATE" },
    { name: 'SEARCH_ITEM.CHANGE_PASSWORD', page: ForgotPassPage, mod: "STG", type: "READ" },
    { name: 'SEARCH_ITEM.CREATE_PASS', page: PassPurposePage, mod: "GNP", type: "CREATE" },
    { name: 'SEARCH_ITEM.METER_CONSUMPTION_CHART', page: MeterPage, data: { index: 1 }, mod: "MTR", type: "READ" },
    { name: 'SEARCH_ITEM.GENERATED_PASSES', page: VisitorTabsPage, data: { index: 1 }, mod: "VMS", type: "READ" },
    { name: 'SEARCH_ITEM.METER_READING', page: MeterPage, mod: "MTR", type: "READ" },
    { name: 'SEARCH_ITEM.MY_STAFF', page: MyStaffTabsPage, data: { index: 0 }, mod: "VMSSTF", type: "READ" },
    { name: 'SEARCH_ITEM.SEARCH_STAFF', page: MyStaffTabsPage, data: { index: 1 }, mod: "VMSSTF", type: "READ" },
    { name: 'SEARCH_ITEM.MY_VEHICLES', page: MyVehiclePage, mod: "VEH", type: "READ" },
    { name: 'SEARCH_ITEM.ADD_VEHICLE', page: AddVehiclePage, mod: "VEH", type: "CREATE" },
    { name: 'SEARCH_ITEM.VISITORS', page: VisitorTabsPage, mod: "VMS", type: "READ" },
  ];

  permissions: any;

  constructor(private login: LoginProvider, private translate : TranslateService) {
    login.getUserDetails().then(val => {
      this.permissions = val.permissions;
    });
  }

  getAllItems() {
    let items = this.allItems;
    let perPipe = new PermissionCheckPipe();

    return this.login.getUserDetails().then(val => {
      // this.permissions = val.permissions;
      return new Promise<any[]>((resolve, reject) => {
        items = items.filter((item) => {
          // if (perPipe.transform(this.permissions, item.mod, item.type)) {
          //   return true;
          // } else {
          //   return false;
          // }
          return true
        });
        resolve(items);
      });
    });

  }

  getItems(val) {
    let items = this.allItems;
    let perPipe = new PermissionCheckPipe();

    return new Promise<any[]>((resolve, reject) => {
      if (val && val.trim() != '') {
        items = items.filter((item) => {
          if (item.name.toLowerCase().indexOf(val.toLowerCase()) > -1) {
            if (perPipe.transform(this.permissions, item.mod, item.type)) {
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        });
        resolve(items);
      } else {
        reject('Type Something');
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/app-search-items/app-search-items.ts